import React, { useState, useEffect, useRef } from 'react';
import { IoIosCheckmarkCircle } from "react-icons/io";
import { send_otp_email,send_otp_mobile,verify_email,verify_mobile,submitForm } from './utils';
import { useNavigate } from "react-router-dom";

function OtpPopup({ onClose,formdata,loader }) {
  const popupRef = useRef(null);

  const [emailOtp, setEmailOtp] = useState('');
  const [mobileOtp, setMobileOtp] = useState('');
  const [emailVerified, setEmailVerified] = useState(false);
  const [mobileVerified, setMobileVerified] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [emailResendTimer, setEmailResendTimer] = useState(120);
  const [mobileResendTimer, setMobileResendTimer] = useState(120);
 const navigate = useNavigate();
  useEffect(() => {
    const timer = setInterval(() => {
      setEmailResendTimer(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [emailResendTimer]);

  useEffect(() => {
    const timer = setInterval(() => {
      setMobileResendTimer(prev => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [mobileResendTimer]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const handleEmailVerify = async () => {
    
    const data = await verify_email(formdata.accountUserEmail,emailOtp)
    if(data)
    {
    setEmailError(false);
    setEmailVerified(true);
    }
    else{
    setEmailError(true);
    setEmailVerified(false);
    }
  };
  const subMitForm = async()=>{
    loader(true);
const data = await submitForm(formdata)
    loader(false);
if(data)
{
navigate("/thankyoupageforonboarding");
  onClose()


  
}
  }

  const handleMobileVerify = async () => {
    const data = await verify_mobile(formdata.accountUserMobile,mobileOtp)
    if(data) {
setMobileVerified(true);
      setMobileError(false);

    }
    else
    {
setMobileVerified(false);
      setMobileError(true);
    
    }
  };

  const handleEmailResend = () => {
    send_otp_email(formdata.accountUserEmail);
    setEmailError(false);
    setEmailVerified(false);
    setEmailResendTimer(30);
  };

  const handleMobileResend = () => {
    send_otp_mobile(formdata.accountUserMobile)
    setMobileError(false);
    setMobileVerified(false);
    setMobileResendTimer(30);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(2px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div
        ref={popupRef}
        style={{
          backgroundColor: 'white',
          padding: '25px',
          width: '90%',
          maxWidth: '550px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          borderRadius: '0px',
          position: 'relative'
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '12px',
            right: '15px',
            background: 'none',
            border: 'none',
            fontSize: '22px',
            cursor: 'pointer',
            color: '#999',
            zIndex: 10
          }}
        >
          ×
        </button>

        <h4 style={{
          margin: '0 0 20px 0',
          fontSize: '18px',
          fontWeight: '600',
          textAlign: 'center',
          paddingBottom: '15px',
          borderBottom: '1px solid #f0f0f0',
          color : '#0CB744'
        }}>
          OTP Verification
        </h4>

        {/* Email */}
        <div style={{ marginBottom: '25px' }}>
          <label style={{
            display: 'block',
            fontWeight: '500',
            marginBottom: '8px',
            fontSize: '14px',
            color: '#555'
          }}>Email Verification</label>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            border: `1px solid ${emailError ? '#ff4444' : emailVerified ? '#0CB744' : '#ccc'}`,
            padding: '0 10px',
            backgroundColor: emailVerified ? '#f8fff8' : '#fff'
          }}>
            <input
              type="text"
              style={{
                flex: 1,
                padding: '12px 10px',
                border: 'none',
                outline: 'none',
                fontSize: '15px',
                background: 'transparent'
              }}
              value={emailOtp}
              onChange={(e) => setEmailOtp(e.target.value)}
              disabled={emailVerified}
              placeholder="Enter OTP"
            />
            {emailVerified ? (
              <IoIosCheckmarkCircle color="#0CB744" size={22} />
            ) : (
              <>
                <button
                  onClick={handleEmailVerify}
                  type='button'
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#0CB744',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    marginLeft: '8px'
                  }}
                >
                  Verify
                </button>
                <span style={{ margin: '0 6px', color: '#aaa' }}>|</span>
                <button
                  onClick={handleEmailResend}
                  disabled={emailResendTimer > 0}
                  type='button'
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#0CB744',
                    cursor: emailResendTimer > 0 ? 'default' : 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  {emailResendTimer > 0 ? `Resend (${emailResendTimer})` : 'Resend'}
                </button>
              </>
            )}
          </div>
          {emailError && (
            <div style={{ color: '#ff4444', fontSize: '13px', marginTop: '6px' }}>
              Incorrect OTP, Try Again
            </div>
          )}
        </div>

        {/* Mobile */}
        <div style={{ marginBottom: '25px' }}>
          <label style={{
            display: 'block',
            fontWeight: '500',
            marginBottom: '8px',
            fontSize: '14px',
            color: '#555'
          }}>Mobile No. Verification</label>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            border: `1px solid ${mobileError ? '#ff4444' : mobileVerified ? '#0CB744' : '#ccc'}`,
            padding: '0 10px',
            backgroundColor: mobileVerified ? '#f8fff8' : '#fff'
          }}>
            <input
              type="text"
              style={{
                flex: 1,
                padding: '12px 10px',
                border: 'none',
                outline: 'none',
                fontSize: '15px',
                background: 'transparent'
              }}
              value={mobileOtp}
              onChange={(e) => setMobileOtp(e.target.value)}
              disabled={mobileVerified}
              placeholder="Enter OTP"
            />
            {mobileVerified ? (
              <IoIosCheckmarkCircle color="#0CB744" size={22} />
            ) : (
              <>
                <button
                  onClick={handleMobileVerify}
                  type='button'
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#0CB744',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    marginLeft: '8px'
                  }}
                >
                  Verify
                </button>
                <span style={{ margin: '0 6px', color: '#aaa' }}>|</span>
                <button
                  onClick={handleMobileResend}
                  disabled={mobileResendTimer > 0}
                  type='button'
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#0CB744',
                    cursor: mobileResendTimer > 0 ? 'default' : 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  {mobileResendTimer > 0 ? `Resend (${mobileResendTimer})` : 'Resend'}
                </button>
              </>
            )}
          </div>
          {mobileError && (
            <div style={{ color: '#ff4444', fontSize: '13px', marginTop: '6px' }}>
              Incorrect OTP, Try Again
            </div>
          )}
        </div>

        <button
        type='button'
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#0CB744',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: 'pointer',
            fontWeight: '500',
            opacity: (emailVerified && mobileVerified) ? 1 : 0.6,
            pointerEvents: (emailVerified && mobileVerified) ? 'auto' : 'none'
          }}
          onClick={subMitForm}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default OtpPopup;
